import { ActionType } from '../infrastructure/actionTypes';
import { IOrderPlacedReportRow } from '../infrastructure/interfaces'

export default (list: Array<IOrderPlacedReportRow> = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_ORDER_PLACED_REPORT_DONE:
      return [...action.costReportRows];
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderPlacedReport.ts